import { ApiService } from './ApiService';
import { IGetOneResponse } from '../util/Types/Generic';
import { sendStreamingMessage } from '../util/streamResponse';
import { LocalStorageService } from './LocalStorageService';

export class XAiService extends ApiService {
  static pathName = '/x-ai';

  static response = (
    body: any,
    type: string,
  ): Promise<IGetOneResponse<any>> => {
    return ApiService.post(`${this.pathName}/${type}`, body);
  };

  static reasoningStream = async (body: any, type: string): Promise<IGetOneResponse<any>> => {
    try {
      const accessToken = LocalStorageService.getItem('accessToken');
      const baseUrl = process.env.REACT_APP_API_URL;

      const response = await fetch(
        `${baseUrl}${this.pathName}/${type}`,
        {
          method: 'POST',
          body: JSON.stringify(body),
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
            Accept: 'text/event-stream',
          },
        },
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message);
      }

      const { message, thinking, usedTokens } = await sendStreamingMessage(
        response,
      );

      return { data: { message, logs: thinking, usedTokens }, status: '200' };
    } catch (error) {
      throw error;
    }
  };

  static getCompletion = async (body: any, type: string): Promise<IGetOneResponse<any>> => {
    if (!body.stream) {
      return this.response(body, type);
    } else {
      return this.reasoningStream(body, type);
    }
  };
}
